import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { TextFormat, Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { APP_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './workflow-documents.reducer';

export const WorkflowDocumentsDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const workflowDocumentsEntity = useAppSelector(state => state.workflowDocuments.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="workflowDocumentsDetailsHeading">
          <Translate contentKey="tycheApp.workflowDocuments.detail.title">WorkflowDocuments</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{workflowDocumentsEntity.id}</dd>
          <dt>
            <span id="workflowId">
              <Translate contentKey="tycheApp.workflowDocuments.workflowId">Workflow Id</Translate>
            </span>
          </dt>
          <dd>{workflowDocumentsEntity.workflowId}</dd>
          <dt>
            <span id="name">
              <Translate contentKey="tycheApp.workflowDocuments.name">Name</Translate>
            </span>
          </dt>
          <dd>{workflowDocumentsEntity.name}</dd>
          <dt>
            <span id="path">
              <Translate contentKey="tycheApp.workflowDocuments.path">Path</Translate>
            </span>
          </dt>
          <dd>{workflowDocumentsEntity.path}</dd>
          <dt>
            <span id="uploadedAt">
              <Translate contentKey="tycheApp.workflowDocuments.uploadedAt">Uploaded At</Translate>
            </span>
          </dt>
          <dd>
            {workflowDocumentsEntity.uploadedAt ? (
              <TextFormat value={workflowDocumentsEntity.uploadedAt} type="date" format={APP_DATE_FORMAT} />
            ) : null}
          </dd>
          <dt>
            <Translate contentKey="tycheApp.workflowDocuments.submissionRequest">Submission Request</Translate>
          </dt>
          <dd>{workflowDocumentsEntity.submissionRequest ? workflowDocumentsEntity.submissionRequest.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/workflow-documents" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/workflow-documents/${workflowDocumentsEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default WorkflowDocumentsDetail;
